/* ============================================================================
   L'EXUDE — Eastern Arabic (Arabic-Indic) numerals on the /ar locale. TEST.
   ----------------------------------------------------------------------------
   TOGGLE: remove the <script src="lx-ar-digits.js"> tag from
   layout/theme.liquid (it sits inside the request.locale.iso_code contains
   'ar' block, next to lx-fonts-ar.css) to revert the whole storefront to
   Western digits. Nothing else references this file.

   What it does: after DOMContentLoaded it walks every rendered TEXT NODE under
   <body> and maps ASCII digits [0-9] to Arabic-Indic digits [٠-٩] (U+0660–
   U+0669). A MutationObserver keeps converting dynamically injected content
   (cart drawer re-renders, quick-add modals, variant price updates).

   Safety rails (this is the "safe test" version):
   - Runs ONLY when <html lang> starts with 'ar' (belt + suspenders: the tag
     itself is only printed on the Arabic locale).
   - TEXT NODES ONLY. Element attributes (hrefs, values, JSON blobs, data-*)
     are never touched, so facet counts in URLs, JSON parsing and any script
     that reads attributes keep working.
   - Skipped subtrees: script / style / noscript / textarea / input / select /
     option, anything contenteditable, and any element carrying the
     data-lx-keep-digits opt-out attribute (put it on a wrapper to keep
     Western digits inside).
   - Decimal separators: '.' and ',' are left as-is (451.30 -> ٤٥١.٣٠).
   - Loop-safe: once converted a node contains no ASCII digits, so the
     characterData mutation our own write triggers is a no-op on re-entry.
   ========================================================================= */
(/* GUARD: .money spans are owned by Doubly Global Currency, which re-parses
   price text client-side and cannot read Eastern digits (blank prices bug,
   caught 2026-07-12) — money keeps Western digits by design. */
function () {
  'use strict';

  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('ar') !== 0) return;

  /* U+0660..U+0669 — index n = Arabic-Indic digit for ASCII digit n */
  var AR = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  var HAS_DIGIT = /[0-9]/;
  var SKIP_TAG = {
    SCRIPT: 1,
    STYLE: 1,
    NOSCRIPT: 1,
    TEXTAREA: 1,
    INPUT: 1,
    SELECT: 1,
    OPTION: 1,
    TEMPLATE: 1
  };

  function toArabicDigits(str) {
    return str.replace(/[0-9]/g, function (d) {
      return AR[d.charCodeAt(0) - 48];
    });
  }

  /* Is THIS element itself one we must not descend into? (Used as the
     TreeWalker subtree-reject test, so each element is checked once.) */
  function skipsSelf(el) {
    return (
      SKIP_TAG[el.tagName] === 1 ||
      el.hasAttribute('data-lx-keep-digits') ||
      el.hasAttribute('contenteditable') ||
      /* .money spans are owned by Doubly Global Currency, which re-parses
         price text client-side and can't read Eastern digits — converting
         them blanked every price (caught live 2026-07-12). Prices keep
         Western digits by design (common Gulf e-commerce convention). */
      (el.classList &&
        (el.classList.contains('money') ||
          (typeof el.className === 'string' && el.className.indexOf('doubly') !== -1)))
    );
  }

  /* Is el, or any ancestor, a skipped element? (Used for mutation roots that
     may already sit INSIDE a skipped subtree.) */
  function insideSkipped(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      if (skipsSelf(n)) return true;
    }
    return false;
  }

  function convertTextNode(node) {
    var v = node.nodeValue;
    if (v && HAS_DIGIT.test(v)) node.nodeValue = toArabicDigits(v);
  }

  /* Convert every eligible text node under root (root may be a text node). */
  function convertTree(root) {
    if (root.nodeType === 3) {
      if (!root.parentElement || !insideSkipped(root.parentElement)) convertTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 11) return; /* elements + fragments only */
    if (root.nodeType === 1 && insideSkipped(root)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeType === 1) {
          /* REJECT prunes the whole subtree; SKIP just keeps descending */
          return skipsSelf(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        }
        return HAS_DIGIT.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var current;
    while ((current = walker.nextNode())) convertTextNode(current);
  }

  function init() {
    if (!document.body) return;
    convertTree(document.body);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          var p = m.target.parentElement;
          if (!p || !insideSkipped(p)) convertTextNode(m.target);
        } else if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) convertTree(m.addedNodes[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
